import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSahibindenComponent } from './simple-icons-sahibinden.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSahibindenComponent ],
    exports:      [ SimpleIconsSahibindenComponent ],
    bootstrap:    []
})
export class SimpleIconsSahibindenModule {}
